<mat-form-field class="autocomplete-field">
  <input matInput [matAutocomplete]="autocomplete" [formControl]="control" autocomplete="off" />
</mat-form-field>

<mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayWith" (optionSelected)="handleClose($event)">
  @if (isAutocompleteLoading) {
  <mat-option>
    <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
  </mat-option>
  } @if (options?.length) {
  <cdk-virtual-scroll-viewport [style.height.px]="height" itemSize="45" #scrollComponent linScrollable (scrollPosition)="scrollHandler()">
    <ng-container #container>
      <mat-option value="">
        <span></span>
      </mat-option>
      @if (options?.length) {
      <mat-option *cdkVirtualFor="let option of options" [value]="option" #viewport class="example-item">
        <span>{{ displayWith(option) }}</span>
      </mat-option>
      @if (isLoading$ | async) {
      <mat-option>
        <mat-spinner strokeWidth="2" diameter="20" color="accent"> </mat-spinner>
      </mat-option>
      } }

      <!-- <ng-template #empty> -->
      <!-- </ng-template> -->
      <!-- <mat-option *ngIf="autocompleteOptions | async">
          <mat-spinner strokeWidth="2" diameter="20" color="accent"> </mat-spinner>
        </mat-option> -->
    </ng-container>
  </cdk-virtual-scroll-viewport>
  }
</mat-autocomplete>
